// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Ap-z","imageAndVideoCount":"Bp-z","imageAndVideoContainer":"Cp-z","viewAllReviews":"Dp-z"};